import type { IPerson } from '../model/IPerson'
import type { ITreeAncestorCouple } from '../model/ITreeAncestorCouple'
import type { ITreeOptions } from '../model/ITreeOptions'
import { expectDefined } from './expectDefined'
import { getImageUrlForSvg } from './getImageUrlForSvg'
import { getParentCouple } from './getParentCouple'

export async function makeTreeAncestorCouple(
	options: ITreeOptions,
	personId: string,
	level = 1,
): Promise<ITreeAncestorCouple | null | undefined> {
	try {
		const parentCouple = getParentCouple(options.data, personId)
		if (!parentCouple || (!parentCouple.maleId && !parentCouple.femaleId))
			return undefined

		let femaleImage: string | undefined
		let female: IPerson | undefined
		if (parentCouple.femaleId) {
			female = expectDefined(options.data.personsById[parentCouple.femaleId])
			femaleImage = await getImageUrlForSvg(female, options)
		}

		let maleImage: string | undefined
		let male: IPerson | undefined
		if (parentCouple.maleId) {
			male = expectDefined(options.data.personsById[parentCouple.maleId])
			maleImage = await getImageUrlForSvg(male, options)
		}

		return {
			level,
			couple: parentCouple,
			female: female,
			femaleImage,
			male: male,
			maleImage,
			femaleNext: parentCouple.femaleId
				? await makeTreeAncestorCouple(
						options,
						parentCouple.femaleId,
						level + 1,
					)
				: undefined,
			maleNext: parentCouple.maleId
				? await makeTreeAncestorCouple(options, parentCouple.maleId, level + 1)
				: undefined,
		}
	} catch (e) {
		console.log(`[t9h0s1] Failing person:`, personId)
		throw e
	}
}
